<script>
  
  import QuestionSelect from "./QuestionSelect.svelte";
  import InputForces from "./InputForces.svelte";
  import {dfsScore} from "./dfsScore.js"
  let data = {
    sex: "-1",
    Fatigue: "-1",
    LossOfAppetite: "-1",
    walk: "-1",
    stairs: "-1",
    lowActivity: "-1",
    left: { first: null, second: null },
    right: { first: null, second: null },
  };

  // validation
  $: notMissed=Object.keys(data).filter((k) => data[k] == "-1").length==0
  $: gotGrip=["left", "right"].filter((k) => data[k]["first"] == 0).length==0
  $: isValid=notMissed && gotGrip  

  // scores
  $: dfs=dfsScore(data)
  $: theScore=dfs['dfs'].toFixed(3)
  const fragilita=["Non fragile","Pre-fragile", "Fragile"]
  const fragilitaClass=["normal","pre-fragile", "fragile"]
  $: isFragile=fragilita[1+dfs['isFragile']];
  $: resultsClass=isValid?fragilitaClass[1+dfs['isFragile']]:'';
  // Possible answers
  const choicesSex=[
      { value: "f", text: "Donna" },
      { value: "m", text: "Uomo" },
  ];

  const siNo = [
    { value: "1", text: "Si" },
    { value: "0", text: "No" },
  ];

  const choicesLossOfAppetite = [
    {
      value: "less",
      text: "Mangia meno del solito",
    },
    {
      value: "same",
      text: "Mangia come al solito",
    },
    {
      value: "more",
      text: "Mangia più del solito",
    },
  ];
  
  const choicesLowActivity = [
    { value: "1", text: "Più di una volta alla settimana" },
    { value: "2", text: "Una volta alla settimana" },
    { value: "3", text: "Da una a tre volte al mese" },
    { value: "4", text: "Quasi mai o mai" },
  ];
  
</script>
<main>
  <h1>Indice Fragilità</h1>
  
  <QuestionSelect
    bind:value={data.sex}
    choices={choicesSex}>Sesso</QuestionSelect
  >
  <h2>Esaurimento</h2>
  <QuestionSelect bind:value={data.Fatigue} choices={siNo}
    >Nell'ultimo mese, si è sentito troppo stanco per fare le cose che voleva
    fare?</QuestionSelect
  >
  <h2>Appetito</h2>
  <QuestionSelect bind:value={data.LossOfAppetite} choices={choicesLossOfAppetite}
    >Com'è l'appetito?</QuestionSelect
  >
  <h2>Forza di presa della mano</h2>
  <em>(Forza massima)</em>
  <InputForces bind:first={data.right.first} bind:second={data.right.second}
    >Mano destra</InputForces
  >
  <InputForces bind:first={data.left.first} bind:second={data.left.second}
    >Mano sinistra</InputForces
  >
  <h2>Difficoltà funzionali</h2>
  <h3>
    Lei ha difficoltà a svolgere qualcuna delle questi attività a causa di un
    problema di salute?
  </h3>
  <em
    >(Escludendo quelle difficoltà che si aspetta possano durare meno di tre
    mesi)</em
  >
  <QuestionSelect bind:value={data.walk} choices={siNo}
    >Camminare per 100 metri:</QuestionSelect
  >
  <QuestionSelect bind:value={data.stairs} choices={siNo}
    >Salire una rampa di scale senza fermarsi a riposare</QuestionSelect
  >
  <h2>Attività fisica</h2>
  <QuestionSelect bind:value={data.lowActivity} choices={choicesLowActivity}
    >Quanto spesso fa delle attività che richiedono un basso o moderato
    dispendio di energia, come giardinaggio, lavare l'auto o fare una
    passeggiata?</QuestionSelect
  >
  <fieldset class="results{' '+resultsClass}" class:isvalid={isValid} >
    <legend>Risultato</legend>
    {#if isValid}
      <label>indice <input type="text" readonly value={theScore}/></label>
      <label>Stato <input type="text" readonly value={isFragile}/></label>
    {:else}
    Compilare la scheda
    {/if}
  </fieldset>
</main>

<style>
  main {
    padding: 0.5ch;
    max-width: 80ch;
    margin: 0 auto;
  }
  .results{
    border-radius: 5px;
        background: #c4e7c3b9;
        margin: 1rem;
        padding: 1rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        position: relative;
        border: 2px groove threedface;
        max-width: 80ch;
  }
  .results.pre-fragile{
    background: #FFBF00;
  }
  .results.fragile{
    background: #ff3e0091;
  }
  .isvalid{
    background-color:#052dbf54;
  }
  h1 {
    text-align: center;
  }
  h1,
  h2 {
    color: #ff3e00;
  }
</style>
